import * as yup from "yup";

export const SoftMaterialItemSchema = yup.object().shape({
  itemName: yup.string(),
  quantity: yup
    .number()

    .nullable(), // If this is optional
  quantityUnit: yup.string().nullable(), // You can add a validation if units are specific
  rate: yup.number().nullable(),
  width: yup.string().nullable(),
  length: yup.string().nullable(),
  perQuantityArea: yup
    .number()

    .nullable(),
  totalArea: yup
    .number()

    .nullable(),
});

export const SoftMaterialPlanningSchema = yup.object().shape({
  gable: yup.object().shape(SoftMaterialItemSchema.fields),

  insectNet1: yup.object().shape(SoftMaterialItemSchema.fields),

  insectNet2: yup.object().shape(SoftMaterialItemSchema.fields),

  apprun1: yup.object().shape(SoftMaterialItemSchema.fields),

  topShadeNet: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet: yup.object().shape(SoftMaterialItemSchema.fields),

  curtain1: yup.object().shape(SoftMaterialItemSchema.fields),

  curtain2: yup.object().shape(SoftMaterialItemSchema.fields),

  cornerPaper: yup.object().shape(SoftMaterialItemSchema.fields),

  gutter: yup.object().shape(SoftMaterialItemSchema.fields),

  door: yup.object().shape(SoftMaterialItemSchema.fields),

  profile: yup.object().shape(SoftMaterialItemSchema.fields),

  topPolyfilm: yup.object().shape(SoftMaterialItemSchema.fields),

  secondPolyfilm: yup.object().shape(SoftMaterialItemSchema.fields),

  frontBackCurtain: yup.object().shape(SoftMaterialItemSchema.fields),

  gutterSide: yup.object().shape(SoftMaterialItemSchema.fields),

  apprun2: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet1: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet2: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet3: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet4: yup.object().shape(SoftMaterialItemSchema.fields),

  insectNet: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet50percent: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet2s3p2m: yup.object().shape(SoftMaterialItemSchema.fields),

  shadeNet3s3p2m: yup.object().shape(SoftMaterialItemSchema.fields),

  pollyhouseDesign1: yup.mixed(),
  pollyhouseDesign2: yup.mixed(),
});
